import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ScanReportProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'scan-report'
}
